import { render, staticRenderFns } from "./DependenciesSearchItems.vue?vue&type=template&id=7a9efa1e&scoped=true&"
import script from "./DependenciesSearchItems.vue?vue&type=script&lang=js&"
export * from "./DependenciesSearchItems.vue?vue&type=script&lang=js&"
import style0 from "./DependenciesSearchItems.vue?vue&type=style&index=0&id=7a9efa1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9efa1e",
  null
  
)

export default component.exports